export class Club {
  constructor(
    readonly id_club: string,
    readonly name_club: string,
    readonly city: string,
    readonly postcode: string,
    readonly club_image: string,
    readonly address: string,
    readonly google_maps_link: string,
    readonly telephone: string,
    readonly website: string,
    readonly all_courts_sacra_active: boolean,
  ) {}
}
